import $ from '@vaersaagod/tools/Dom';
import agent from '@vaersaagod/tools/request';

export default el => {
    const list = $(el).find('[data-list]');
    const button = $(el).find('[data-button]');

    const loadContent = e => {
        e.preventDefault();
        agent.get(button.attr('href')).then(res => {
            const response = $(res.text);
            const items = response.find('[data-item]');
            const loadMore = response.find('[data-button]');

            history.replaceState({}, document.title, button.attr('href'));

            if (items.length) {
                list.append(items);
            }

            if (loadMore.length) {
                button.attr('href', loadMore.attr('href'));
            } else {
                button.remove();
            }
        }, error => {
            console.error(error);
        });
    };

    const init = () => {
        button.on('click', loadContent);
    };

    const destroy = () => {
        button.off('click', loadContent);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/PaginatedList.js